import { TaxReturnTypes } from 'Containers/Result/utils';
import { FRONT_PLANS } from 'Constants/plans';
import { PlansType, ResultType } from 'Types/common';

export interface IncomesObjectType {
  employee: boolean;
  resico: boolean;
  rent: boolean;
  platformDigital: boolean;
  investments: boolean;
  herence: boolean;
}

export const initialState = {
  employee: false,
  resico: false,
  rent: false,
  platformDigital: false,
  investments: false,
  herence: false,
};
export const servicesInitialState = {
  mailAsesory: false,
  lowCost: false,
  payLater: false,
  callAsesory: false,
  improveResult: false,
};

export interface ProductsObjectType {
  mailAsesory: boolean;
  lowCost: boolean;
  payLater: boolean;
  callAsesory: boolean;
  improveResult: boolean;
}
export interface smartFilterResponse {
  plan?: PlansType[];
  isVip: boolean;
  planRecommended?: FRONT_PLANS;
  stateFunctions: {
    updateIncomes: (id) => void;
    updateProducts: (id) => void;
    products: { [key: string]: boolean };
    variable: { [key: string]: boolean };
  };
}

export const filterPlans = (
  plans?: PlansType[],
  result?: ResultType
): { plansToRender?: PlansType[]; plansToRenderPremium?: PlansType[] } => {
  if (plans?.length === 2) return { plansToRender: plans.reverse(), plansToRenderPremium: plans };
  const plansToRenderPremium = plans?.filter(
    item => item.name === FRONT_PLANS.FULL_PLUS || item.name === FRONT_PLANS.PRO_PLUS
  );

  const plansToRender = plans?.filter(
    item => item.name !== FRONT_PLANS.FULL_PLUS && item.name !== FRONT_PLANS.PRO_PLUS
  );

  const payLaterPlan = plansToRender?.find(item => item.name === FRONT_PLANS.FLEX);
  const getPriceMinimun = parseInt(payLaterPlan?.price?.amountDecimal || '299', 10);

  const filterPayLater = result
    ? Math.abs(result.taxReturnResult) > getPriceMinimun &&
      result.taxReturnType === TaxReturnTypes.TO_RETURN
      ? plansToRender
      : plansToRender?.filter(item => item.name !== FRONT_PLANS.FLEX)
    : plansToRender;

  return {
    plansToRender: filterPayLater,
    plansToRenderPremium,
  };
};

export const getRecommendedPlan = (
  plans: PlansType[],
  products: ProductsObjectType
): PlansType[] | undefined => {
  if (products.lowCost) {
    const planPro = plans?.filter(
      item => item.name === FRONT_PLANS.PRO || item.name === FRONT_PLANS.PRO_PLUS
    );
    return planPro;
  }

  if (products.callAsesory || products.mailAsesory || products.improveResult) {
    const planFull = plans?.filter(
      item => item.name === FRONT_PLANS.FULL || item.name === FRONT_PLANS.FULL_PLUS
    );
    return planFull;
  }

  if (products.payLater) {
    const payLater = plans?.filter(item => item.name === FRONT_PLANS.FLEX);
    return payLater;
  }
  return undefined;
};

export const filterPremiumPlans = (
  products: ProductsObjectType,
  plans: PlansType[]
): PlansType[] | undefined => {
  if (products.lowCost) {
    return plans.filter(item => item.name === FRONT_PLANS.PRO_PLUS);
  }
  if (products.callAsesory || products.mailAsesory || products.improveResult) {
    return plans.filter(item => item.name === FRONT_PLANS.FULL_PLUS);
  }
  return undefined;
};

export const getPremiumFilteredPlan = (
  products: ProductsObjectType,
  incomes: IncomesObjectType,
  plans: PlansType[]
): PlansType[] | undefined => {
  if (
    (incomes.rent || incomes.resico || incomes.platformDigital) &&
    (incomes.employee || incomes.investments || incomes.herence)
  ) {
    const planFilter: PlansType[] | undefined = filterPremiumPlans(products, plans);

    return planFilter;
  }
  if (
    (incomes.rent || incomes.resico || incomes.platformDigital) &&
    !incomes.employee &&
    !incomes.investments &&
    !incomes.herence
  ) {
    const planFilter: PlansType[] | undefined = filterPremiumPlans(products, plans);
    return planFilter;
  }
  return undefined;
};

export const getReturnIncomePlans = (
  products: ProductsObjectType,
  incomes: IncomesObjectType,
  plans: PlansType[]
): { isToRenderBasic: boolean; recommendedPlan: FRONT_PLANS } => {
  const isToRenderBasic =
    (incomes.employee || incomes.investments || incomes.herence) &&
    !incomes.rent &&
    !incomes.resico &&
    !incomes.platformDigital;

  const planFilter: PlansType[] = getRecommendedPlan(plans, products) || [];
  const premiumFiltered = getPremiumFilteredPlan(products, incomes, plans) || [];
  const recommendedPlan = isToRenderBasic ? planFilter[0]?.name : premiumFiltered[0]?.name;
  return {
    isToRenderBasic,
    recommendedPlan,
  };
};
